module.exports = __webpack_public_path__ + "fonts/NunitoSans_10pt-Regular.1c011092.ttf";